import { combineReducers } from '@reduxjs/toolkit'

import list from './listSlice'
import dashboard from './dashboardSlice'
import admins from './adminsSlice'
import roles from './rolesSlice'
import users from './usersSlice'
import stores from './storesSlice'
import storeUsers from './storeUsersSlice'
import bankAccounts from './bankAccountsSlice'
import bankTransactions from './bankTransactionsSlice'
import walletTransactions from './walletTransactionsSlice'
import brands from './brandsSlice'
import categories from './categoriesSlice'
import attributes from './attributesSlice'
import expenses from './expensesSlice'
import customers from './customersSlice'
import vendors from './vendorsSlice'
import referrals from './referralsSlice'
import products from './productsSlice'
import purchases from './purchasesSlice'
import storeOrders from './storeOrdersSlice'
import orders from './ordersSlice'
import analysis from './analysis'
import loginHistory from './loginHistorySlice'

const reducer = combineReducers({
    list,
    dashboard,
    admins,
    roles,
    users,
    stores,
    storeUsers,
    bankAccounts,
    bankTransactions,
    walletTransactions,
    brands,
    categories,
    attributes,
    expenses,
    customers,
    vendors,
    referrals,
    products,
    purchases,
    storeOrders,
    orders,
    analysis,
    loginHistory,
})

export default reducer
